// Triggers.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Triggers() {
    return (
        <PageLayout title="Triggers" subtitle="Triggers overview">
            <div className="container flex col box-container">
                {/* <div className="box">Triggers</div> */}
            </div>
        </PageLayout>   
    );
}

export default Triggers;
